// extracted by mini-css-extract-plugin
export default {"main":"Landing_main__eybTz","container":"Landing_container__XxEVV","lines":"Landing_lines__qYma0","contents":"Landing_contents__47ICX"};